module.exports = __webpack_public_path__ + "ed5e925d68a0f41ac6098a3c18b27bf9.svg";